import { Outlet } from "react-router-dom";
import { LoginFooter } from "./LoginFooter";
import { LoginHeader } from "./LoginHeader";
import { LoginLeftChart } from "./LoginLeftChart";

export function LoginLayout() {
    return (
        <>
            <div class="m-0 p-0 row sticky-top">
                <div class="m-0 p-0 col-sm-12">
                    <LoginHeader/>
                </div>    
            </div>
            <div class="m-0 p-0 row align-items-center bodyheight overflow-auto">
                <div class="m-0 p-0 d-none d-md-block col-md-1 col-xl-2"></div>
                <div class="m-0 p-0 d-none d-md-block col-md-4 col-xl-3"><LoginLeftChart/></div>    
                <div class="m-0 p-0 d-none d-md-block col-md-2 col-xl-2"></div>
                <div class="m-0 p-0         col-sm-12 col-md-4 col-xl-3"><Outlet/></div> 
                <div class="m-0 p-0 d-none d-md-block col-md-1 col-xl-2"></div>
            </div>
            <div class="m-0 p-0 row">
                <div class="m-0 p-0 col-sm-12">
                    <LoginFooter/>
                </div>    
            </div>
        </>
    )
}